import {Component, OnInit} from "@angular/core";
import {ActivatedRoute} from "@angular/router";
import {DomSanitizer, SafeResourceUrl} from "@angular/platform-browser";
import {HttpClient} from "@angular/common/http";
import {firstValueFrom} from "rxjs";
import {AppearanceService} from "../../../core/services/services/appearance.service";

@Component({
	selector: "app-employee-operations-iframe",
	templateUrl: "./employee-profilemap.component.html",
	standalone: true,
	styleUrls: ["./employee-profilemap.component.scss"],
})
export class EmployeeProfilemapComponent implements OnInit {
	personnelNumber: string;
	url: SafeResourceUrl;
	lang: string;

	constructor(
		private route: ActivatedRoute,
		private sanitizer: DomSanitizer,
		private http: HttpClient,
		private appearanceService: AppearanceService,
	) {}

	ngOnInit(): void {
		this.route.params.subscribe((params) => {
			this.personnelNumber = params["persNr"];
		});
		this.setUrl();
	}

	async setUrl() {
		this.url = this.sanitizer.bypassSecurityTrustResourceUrl("");

		await this.appearanceService.init();
		this.lang = this.appearanceService.getLanguage();

		let iFrameURL =
			(await firstValueFrom(this.http.get("/mep/global/profilemapLandingPageOnly", {responseType: "text"}))) +
			this.personnelNumber;
		if (iFrameURL) this.url = this.sanitizer.bypassSecurityTrustResourceUrl(iFrameURL + "/" + this.lang);
	}
}
